import * as actionTypes from './actionTypes';

const initialState = {
    // For fetching PC product
    erasure: {
        count: 0,
        list: [],
        loading: false
    },
    palette: {
        count: 0,
        list: [],
        loading: false
    }
};

export const fetchErasureHistoryInit = () => {
    return {
        type: actionTypes.FETCH_ERASURE_HISTORY_LIST_START
    };
}

const fetchErasureHistoryListStart = (state) => {
    return { ...state, loading: true };
};

const fetchErasureHistoryListSuccess = (state, action) => {
    return {
        ...state,
        erasure: {
            list: action.list,
            count: action.count,
            loading: false
        }
    };
};

const fetchErasureHistoryListFail = (state) => {
    return {
        ...state,
        loading: false
    };
};

export const fetchPaletteHistoryInit = () => {
    return {
        type: actionTypes.FETCH_PALETTE_HISTORY_LIST_START
    };
}

const fetchPaletteHistoryListStart = (state) => {
    return { ...state, loading: true };
};

const fetchPaletteHistoryListSuccess = (state, action) => {
    return {
        ...state,
        palette: {
            list: action.list,
            count: action.count,
            loading: false
        }
    };
};

const fetchPaletteHistoryListFail = (state) => {
    return {
        ...state,
        loading: false
    };
};



const reducer = (state = initialState, action) => {
    switch (action.type) {
        // Fetching user
        case actionTypes.FETCH_ERASURE_HISTORY_LIST_START:
            return fetchErasureHistoryListStart(state, action);
        case actionTypes.FETCH_ERASURE_HISTORY_LIST_SUCCESS:
            return fetchErasureHistoryListSuccess(state, action);
        case actionTypes.FETCH_ERASURE_HISTORY_LIST_FAIL:
            return fetchErasureHistoryListFail(state, action);
        case actionTypes.FETCH_PALETTE_HISTORY_LIST_START:
            return fetchPaletteHistoryListStart(state, action);
        case actionTypes.FETCH_PALETTE_HISTORY_LIST_SUCCESS:
            return fetchPaletteHistoryListSuccess(state, action);
        case actionTypes.FETCH_PALETTE_HISTORY_LIST_FAIL:
            return fetchPaletteHistoryListFail(state, action);
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};

export default reducer;
